import HasID from "@/models/HasID";
import TrackedObject from "@/models/TrackedObject";
import { Patient } from "@/models/Patient";
import { Program } from "@/models/Program";
import { DrugProgram } from "./Drug/Drug";

export interface PatientAssistanceProgram extends HasID, TrackedObject {
    id: number;
    imageId: number;
    patientId: number;
    status: PatientAssistanceProgramStatus;
    attachmentIds: number[];
    patient: Patient;
    edit: any;
    program?: Program;
    expirationDate?: Date;
    authorizedFills?: number;
    rejectReason?: string;
    drug?: DrugProgram;
    nextTouchDate?: Date;
    storeId?: number;
    lockedBy?: string;
    lockExpires?: string;
}

export enum PatientAssistanceProgramStatus {
    Created,
    ApplicationSubmitted,
    Approved,
    Denied,
    Deleted,
    AwaitingPatient,
    AwaitingPrescriber,
    Received
}

export class PatientAssistanceProgram {
    constructor(obj?: PatientAssistanceProgram) {
        if (obj) Object.assign(this, obj);
        if (obj?.patient) this.patient = new Patient(obj.patient);

        this.edit = {};
    }
}
